export const yaData = [{
        question: "Live with meaning.",
        answer: "Influence the world around you. And we're not talking about having thousands of followers on Instagram. Highway of Holiness young adults is a community ready to live with purpose to influence the world around us. "
    },
    {
        question: "Live in an authentic community.",
        answer: "There are no strangers here. Find real friends and experience a genuine community with people who aren't afraid to move past shallow conversations and grow in our faith together. "
    },
    
    {
        question: "Live for Jesus.",
        answer: "We don't shy away from the hard questions and don't think you should either. Instead, we create space for you to ask life's most meaningful questions and get to know the real Jesus in the process."
    },

]